import tmhRequest from '@/config/tmhRequest'

export default {

    searchSchedulingType: function (data) {
        return tmhRequest({
            url: '/employee/tmh/schedulingtype/searchschedulingtype',
            method: 'post',
            params: data,
        })
    },


    searchListSchedulingType: function (data) {
        return tmhRequest({
            url: '/employee/tmh/schedulingtype/searchlistschedulingtype',
            method: 'post',
            params: data,
        })
    },


    searchSchedulingTypeCount: function (data) {
        return tmhRequest({
            url: '/employee/tmh/schedulingtype/searchschedulingtypecount',
            method: 'post',
            params: data,
        })
    },

    searchSchedulingTypeByPage: function (data) {
        return tmhRequest({
            url: '/employee/tmh/schedulingtype/searchschedulingtypebypage',
            method: 'post',
            params: data,
        })
    },
    addSchedulingType: function (data) {
        return tmhRequest({
            url: '/employee/tmh/schedulingtype/addschedulingtype',
            method: 'post',
            params: data,
        })
    }, 
    editSchedulingType: function (data) {
        return tmhRequest({
            url: '/employee/tmh/schedulingtype/editschedulingtype',
            method: 'post',
            params: data,
        })
    },
    deleteSchedulingType: function (data) {
        return tmhRequest({
            url: '/employee/tmh/schedulingtype/deleteschedulingtype',
            method: 'post',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/employee/schedulingtype.js